module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "truck"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "m-b-lg"
  }, [_vm._v("Details")]), _vm._v(" "), (_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('truck.user_id')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('selectize', {
    directives: [{
      name: "validate",
      rawName: "v-validate:user",
      value: ({
        required: _vm.$user.isAdminOrCoordinator
      }),
      expression: "{ required: $user.isAdminOrCoordinator }",
      arg: "user"
    }],
    attrs: {
      "name": "user_id",
      "options": _vm.initialUserOptions,
      "fetch-results": _vm.fetchUserResults
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('truck.registration')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Truck Registration (required)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration),
      expression: "registration"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.truckNotEditable,
      "name": "registration",
      "placeholder": "Truck Registration (required)"
    },
    domProps: {
      "value": (_vm.registration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registration = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Truck Make")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.make),
      expression: "make"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.truckNotEditable,
      "placeholder": "Truck Make"
    },
    domProps: {
      "value": (_vm.make)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.make = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Truck Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.truckNotEditable,
      "placeholder": "Truck Model"
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Make Year")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.truckNotEditable,
      "placeholder": "Make Year"
    },
    domProps: {
      "value": (_vm.year)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.year = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Base Location")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "location_id",
      "disabled": _vm.truckNotEditable,
      "options": _vm.initialLocationOptions,
      "fetch-results": _vm.fetchLocationResults
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "m-b-lg"
  }, [_vm._v("Prime Mover Photo")]), _vm._v(" "), _c('photo-cropper', {
    attrs: {
      "name": "truck",
      "photo-storage-path": _vm.truck.photo_storage_path,
      "original-name": _vm.truck.photo_name,
      "original-data-uri": _vm.originalPhotoDataUri,
      "class-name": "truck-photo",
      "label-text": "File"
    },
    model: {
      value: (_vm.photo),
      callback: function($$v) {
        _vm.photo = $$v
      },
      expression: "photo"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox ibox-primary-truck"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-3"
  }, [(_vm.driverDecorated.thumbnail_url) ? _c('img', {
    staticClass: "truck-profile",
    attrs: {
      "src": _vm.driverDecorated.thumbnail_url,
      "alt": "Driver Name"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-md-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group-outer no-margin"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Select Driver")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "driver_id",
      "disabled": _vm.truckNotEditable,
      "options": _vm.initialDriverOptions,
      "fetch-results": _vm.fetchDriverResults
    },
    model: {
      value: (_vm.driver),
      callback: function($$v) {
        _vm.driver = $$v
      },
      expression: "driver"
    }
  })], 1), _vm._v(" "), (_vm.driver) ? _c('p', [(_vm.truck.driver.email) ? [_c('i', {
    staticClass: "fa fa-at"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:${truck.driver.email}"
    }
  }, [_vm._v(_vm._s(_vm.truck.driver.email))]), _c('br')] : _vm._e(), _vm._v(" "), (_vm.truck.driver.mobile) ? [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.truck.driver.mobile) + "\n                  ")] : _vm._e(), _vm._v(" "), _c('ladda-button', {
    staticClass: "m-t-lg",
    attrs: {
      "on-click": _vm.handleRemoveDriver,
      "disabled": _vm.truckNotEditable,
      "type": "danger",
      "size": "small",
      "max-width": true
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Remove Driver\n                  ")])], 2) : _c('p', [_vm._v("\n                   \n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('p', [_vm._v("Please add the configuration options for this truck.")]), _vm._v(" "), _c('ul', {
    staticClass: "list-detail list-detail-configuration"
  }, _vm._l((_vm.truck.configurations), function(config, index) {
    return _c('li', {
      key: config.id
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "config-size col-md-2 col-lg-1"
    }, [_vm._v(_vm._s(config.net_weight) + " t")]), _vm._v(" "), _c('div', {
      staticClass: "config-description col-md-10 col-lg-11"
    }, [_vm._v(_vm._s(config.description))])]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.truckIsEditable && config.deleteable),
        expression: "truckIsEditable && config.deleteable"
      }],
      on: {
        "click": function($event) {
          _vm.handleDeleteConfig(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-alt"
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer ibox-footer-configuration-options"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "configuration"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('configuration.net_weight')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Net Weight")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuration.net_weight),
      expression: "configuration.net_weight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.truckNotEditable,
      "min": "0",
      "name": "net_weight",
      "placeholder": "Net Weight"
    },
    domProps: {
      "value": (_vm.configuration.net_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.configuration.net_weight = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group-outer form-group-outer-description"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('configuration.configuration_id')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('selectize', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control select2-material-placeholder",
    attrs: {
      "name": "configuration_id",
      "disabled": _vm.truckNotEditable,
      "options": _vm.configurationOptions
    },
    model: {
      value: (_vm.configuration.id),
      callback: function($$v) {
        _vm.configuration.id = $$v
      },
      expression: "configuration.id"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-2"
  }, [_c('ladda-button', {
    staticClass: "m-t-sm",
    attrs: {
      "on-click": _vm.handleAddConfiguration,
      "disabled": _vm.truckNotEditable,
      "size": "small",
      "max-width": true
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])], 1)])])])]), _vm._v(" "), _c('driver-modal', {
    attrs: {
      "truck-user": _vm.user
    },
    model: {
      value: (_vm.driver),
      callback: function($$v) {
        _vm.driver = $$v
      },
      expression: "driver"
    }
  }), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.truckNotEditable,
      "on-click": _vm.handleSaveChange
    }
  }, [_vm._v(" Save Changes")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Truck Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Primary Driver")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Configuration Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "m-b-md"
  }, [_c('strong', [_vm._v("Add Configuration:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6eeb536d"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trucks/Form.vue
// module id = 1034
// module chunks = 0